"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAreaField = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var TextArea_1 = __importDefault(require("semantic-ui-react/dist/commonjs/addons/TextArea/TextArea"));
var Icon_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/Icon/Icon"));
var input_1 = require("../../lib/input");
var InfoTooltip_1 = require("../InfoTooltip");
require("./TextAreaField.css");
function renderMessage(props) {
    var error = props.error, warning = props.warning, info = props.info;
    if (error) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Icon_1.default, { name: "remove circle" }),
            " ",
            error));
    }
    if (warning) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Icon_1.default, { name: "warning sign" }),
            " ",
            warning));
    }
    if (info) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Icon_1.default, { name: "info circle" }),
            " ",
            info));
    }
}
var TextAreaField = function (props) {
    var error = props.error, warning = props.warning, info = props.info, restOfProps = __rest(props, ["error", "warning", "info"]);
    delete restOfProps['label'];
    return (React.createElement("div", { className: (0, classnames_1.default)('dcl', 'text-area', {
            error: error,
            warning: !error && warning,
            info: !error && !warning && info
        }) },
        props.label || props.maxLength !== undefined ? (React.createElement("div", { className: "title" },
            props.label ? React.createElement("label", null, props.label) : null,
            props.label && props.tooltip ? (React.createElement(InfoTooltip_1.InfoTooltip, __assign({}, props.tooltip))) : null,
            props.maxLength ? (React.createElement("span", { className: "maxLength" },
                (0, input_1.getInputValueLength)(props.value),
                "/",
                props.maxLength)) : null)) : null,
        React.createElement(TextArea_1.default, __assign({}, restOfProps)),
        React.createElement("p", { className: "message" },
            renderMessage(props),
            "\u00A0")));
};
exports.TextAreaField = TextAreaField;
